import axios from "axios";
import Lien_VIP from "./Lien_VIP.class";

/**
 * @classdesc Liste des liens vip d'un module
 * @kind class
 * @export
 * @class List_Codes_Reduction
 */
export default class List_Lien_VIP {
    id_module;
    list = [];
    /**
     * Creates an instance of List_Lien_VIP.
     * @constructs
     * @kind function
     * @memberof List_Lien_VIP
     */
    constructor(id_module) {
        this.id_module = id_module;
    }

    async fetch() {
        let res = await axios.get("/liens_vip/get.php?id_module=" + this.id_module);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    set(data) {
        for (let i = 0; i < data.length; i++) {
            let lien = new Lien_VIP();
            lien.set(data[i]);
            this.list.push(lien);
        }
    }

    async delete_lien(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                await this.list[i].remove();
                this.list.splice(i, 1);
                return true;
            }
        }
        return false;
    }

    async deactivate(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                await this.list[i].deactivate();
                return true;
            }
        }
        return false;
    }
    async activate(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                await this.list[i].activate();
                return true;
            }
        }
        return false;
    }

    filter_multi_usage() {
        this.list = this.list.filter(lien => lien.mail == "" && !lien.token.includes("lmus"));
    }

}